import styled from 'styled-components';

export const AboutStyles = styled.div`
  section.about-hero {
    .container {
      display: flex;
      flex-direction: column;

      ${props => props.theme.media.lg} {
        flex-direction: row;
        max-width: 1400px;
        justify-content: space-around;
      }

      .hero-title {
        ${props => props.theme.media.xs} {
          margin: 0 auto;
          padding-left: 1rem;
          width: 100%;
          max-width: 330px;
        }

        ${props => props.theme.media.lg} {
          max-width: 100%;
          margin-left: 0rem;
        }

        p {
          color: #3F5261;
          font-family: Poppins;
          font-size: 25px;
          font-style: Italic;
          font-weight: 450;

          ${props => props.theme.media.xs} {
            margin-bottom: 0;
          }
 
          ${props => props.theme.media.lg} {
            font-size: 30px;
          }
        }
      }

      .hero-image-container {
        display: flex;
        justify-content: center;

        ${props => props.theme.media.lg} {
          justify-content: flex-start;
        }
      }

      .hero-image {
        min-width: 250px;
        max-width: 333px;
        
        ${props => props.theme.media.lg} {
          max-width: 390px;
        }
      }

      .hero-text-container {
        ${props => props.theme.media.lg} {
          max-width: 55%;
        }
      }

      .hero-text {
        font-size: 18px;
        font-family: Poppins;
        text-align: center;
        color: #3F5261;
        margin: auto;
        width: 100%;
        max-width: 350px;
        font-weight: 450;
        margin-top: 16px;
        ${props => props.theme.media.lg} {
          max-width: 100%;
          text-align: left;
          font-size: 19px;
          margin-top: 16px;
          margin-bottom: 1rem;
        }
      }

      .hero-subtext {
        font-family: Inter;
        font-size: 16px;
        text-align: center;
        color: #3F5261;
        font-weight: 350;

        ${props => props.theme.media.lg} {
          text-align: left;
          max-width: 590px;
          line-height: 27px;
        }
      }

      .hero-thumbnail-container {
        ${props => props.theme.media.lg} {
          display: flex;
          justify-content: center;
          margin: 80px 62px 50px;
        }
      }

      .hero-thumbnail-small {
        cursor: pointer;
        margin: 20px 0;
        ${props => props.theme.media.lg} {
          display: none;
        }
      }

      .hero-thumbnail-large {
        display: none;
        cursor: pointer;
        ${props => props.theme.media.lg} {
          display: block;
          max-width: 500px;
        }
      }
    }
  }

  section.business-needs {
    background-color: #F8F6F4;

    ${props => props.theme.media.lg} {
      max-height: 231px;
      display: flex;

    }

    .container {
      display: flex;
      flex-direction: column;
      align-items: center;
      ${props => props.theme.media.lg} {
        flex-direction: row;
        justify-content: space-between;

      }
    }

    .business-need-image:nth-child(even) {
      margin: 50px 0;

      ${props => props.theme.media.lg} {
        margin: 0;
      }
    }

    .business-need-image {
      max-width: 212px;
    }
  }

  section.about-services {
    .container {
      ${props => props.theme.media.lg} {
        display: flex;
        
      }
    }

    .about-services-image-container {
      margin-bottom: 10px;
    }
    .about-services-image {
      width: 100%;
      margin: auto;
    }

    .about-services-text-container {
      ${props => props.theme.media.lg} {
        max-width: 550px;
        margin-left: 80px;
      }
    }

    .about-services-title {
      font-family: Poppins;
      color: #3F5261;
      font-size: 26px;
      text-align: center;
      margin-bottom: -5px;

      ${props => props.theme.media.lg} {
        font-size: 40px;
        line-height: 1.3;
        text-align: left;
      }
    }

    .about-services-subtitle {
      margin-top: 10px;

      p {
        font-family: Inter;
        font-size: 15px;
        text-align: center;
        font-weight: 350;

        ${props => props.theme.media.lg} {
          text-align: left;
        }
      }
    }
  }

  section.testimonial {
    .container {
      display: flex;
      flex-direction: column;
      align-items: center;

      ${props => props.theme.media.lg} {
        flex-direction: row;
        justify-content: space-evenly;
        margin-bottom: 100px;
      }
    }

    img {
      width: 173px;
    }

    .testimonial-quote {
      font-family: Inter;
      font-size: 28px;
      text-align: center;
      font-weight: 350;
      font-color: #3F5261;
      max-width: 362px;
      margin-top: 20px;

      ${props => props.theme.media.lg} {
        font-size: 30px;
        font-weight: 500;
        text-align: left;
        max-width: 750px;
      }
    }

    .testimonial-attribution {
      font-family: Inter;
      font-size: 16px;
      font-weight: 350;
      font-color: #3F5261;
      text-align: center;
      margin-top: 20px;

      ${props => props.theme.media.lg} {
        text-align: right;
      }
    }
  }

  .title-group {
    display: flex;
    .title-us {
      font-size: 34px;
      font-weight: 450;
      width: 300px;
    }

    .title-vs {
      height: 2rem;
      top: 3rem;
      position: relative;
      border-bottom: 4px solid ;
      bottom: .5rem;
      font-size: 16px;
    }

    .title-them {
      font-size: 18px;
      font-weight: 400;
      width: 300px;
      position: relative;
      left: 15px;
      top: 2rem;
      ${props => props.theme.media.sm} {
        font-size: 26px;
        font-weight: 400;
        top: 3rem;
      }
    }

  }
`;